import React, { createContext, useContext, useMemo } from 'react';
import { useTelemedicineCategoryContext } from '../../../context/TelemedicineCategoryProvider'
import useOneClickPrescribe from '../hooks/useOneClickPrescribe';
import useMenu from '../hooks/useMenu';
import useCaseAnimations from '../hooks/useCaseAnimations';
import useCEVLogs from '../hooks/useCEVLogs';

const OneClickPrescribeContext = createContext();

export const useOneClickPrescribeContext = () => {
    const context = useContext(OneClickPrescribeContext);
    
    if (!context) {
        throw new Error("useOneClickPrescribeContext must be used within a oneClickPrescribeProvider");
    }
    return context;
};

export const OneClickPrescribeProvider = ({ children, providerHasPinSet }) => {
    const { getTelemedicineCategoryById } = useTelemedicineCategoryContext()

    const {
        pin,
        handlePinChange,
    } = useMenu();

    const {
        categoryCases,
        loading,
        categories,
        showFlaggedCases,
        setShowFlaggedCases,
        showLogs,
        setShowLogs,
        handleCategorySelect,
        handlePrescribe,
        handleViewCase,
        handleDismissCase,
    } = useOneClickPrescribe(pin);

    const {
        displayedCases,
        getCaseAnimationState,
        dismissSuccessCase,
        onFadeComplete,
        onCollapseComplete,
    } = useCaseAnimations(categoryCases, categories.selected);

    const cevLogs = useCEVLogs();

    const contextValue = useMemo(() => ({
        categories,
        loading,
        providerHasPinSet,
        pin,
        categoryCases,
        displayedCases,
        getTelemedicineCategoryById,
        showFlaggedCases,
        setShowFlaggedCases,
        showLogs,
        setShowLogs,
        handlePinChange,
        getCaseAnimationState,
        handleCategorySelect,
        handleViewCase,
        handlePrescribe,
        handleDismissCase,
        dismissSuccessCase,
        onFadeComplete,
        onCollapseComplete,
        cevLogs,
    }), [
        categories,
        loading,
        providerHasPinSet,
        pin,
        categoryCases,
        displayedCases,
        getTelemedicineCategoryById,
        showFlaggedCases,
        setShowFlaggedCases,
        showLogs,
        setShowLogs,
        handlePinChange,
        getCaseAnimationState,
        handleCategorySelect,
        handleViewCase,
        handlePrescribe,
        handleDismissCase,
        dismissSuccessCase,
        onFadeComplete,
        onCollapseComplete,
        cevLogs,
    ]);

    return (
        <OneClickPrescribeContext.Provider value={contextValue}>
            {children}
        </OneClickPrescribeContext.Provider>
    );
};
